import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import { useState } from "react"
import MessagesList from './MessagesList'
function MessagesListFilter() {
    const {groupId} = useParams()
    useTitle('geshtop-Exercise: Messages List')
    const [active,setActive] = useState(true)
    const [q,setQ] = useState('')

    const navigate = useNavigate()
    
   
    const content =(<>
    <div className="filter-form">
        <div className="filter-form-item">
        <label className="form__label form__checkbox-container" htmlFor="active">
                   הודעות פעילות:
                    <input
                        className="form__checkbox"
                        id="active"
                        name="active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                    </label>
                    </div>
                    <div className="filter-form-item">

                    
             

        </div>
        <div className="filter-form-item">
            <input className="form__input" onChange={(e)=>setQ(e.target.value)} />
            </div>
    </div>
 <MessagesList group={groupId} q={q} active={active} />
</> ) 
  return content;
}

export default MessagesListFilter